import React from 'react';
import {
  Input, TestMaterials,
} from 'shared/components';
import './ReviewAndCloseRoomModal.scss';
import CheckedCircle from 'assets/svgs/checkedCircle.svg';
import InfoIconRed from 'assets/svgs/errorSmallIcon.svg';
import PropTypes from 'prop-types';
import { AlertNotice } from 'shared/components';


const Materials = ({
  materials,
  handleInputChange,
  inputValue,
  handleBlur,
  errors,
  errorMessage,
  successMessage,
}) => {
  return (
    <div className="materials-container">
      <TestMaterials materials={materials} />
      {errorMessage && <div className="warning">
        <InfoIconRed/>
        <div>{errorMessage}</div>
      </div>}
      <div className="materials-input-container">
        <Input
          type="number"
          name="scored"
          label="# to be scored"
          value={inputValue.scored}
          errors={errors.scored}
          onChange={handleInputChange}
          required
        >
        </Input>
        <Input
          type="number"
          name="voided"
          label="# voided"
          value={inputValue.voided}
          errors={errors.voided}
          onChange={handleInputChange}
          required
        >
        </Input>
        <Input
          type="number"
          name="replaced"
          label="# replaced"
          value={inputValue.replaced}
          errors={errors.replaced}
          onChange={handleInputChange}
          required
        >
        </Input>
      </div>
      {successMessage &&
        <AlertNotice
          message={successMessage}
          type="success"
          noBorder
        />
      }
    </div>
  );
};

export default Materials;

Materials.propTypes = {
  materials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  successMessage: PropTypes.string.isRequired,
  inputValue: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
};
